module.exports = __webpack_public_path__ + "img/swithc-wep.6d751fbb.png";